import filterAPI from "../api/filterAPI";
import { ActionTypesScreen4 } from "app/constants";


export function fetchAverageDataScreen4(region_name, naics_dropdown_value, jobtype_dropdown_value) {
  return (dispatch) => {
    filterAPI
      .getAverageDetailsScreen4({"region_name": region_name, "naics_dropdown_value": naics_dropdown_value, "jobtype_dropdown_value": jobtype_dropdown_value })
      .then((res) => {
        let averageDataScreen4 = res.data.data;
        dispatch(handleAverageDataScreen4(averageDataScreen4));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

function handleAverageDataScreen4(data) {
  return {
    type: ActionTypesScreen4.GET_AVERAGE_DATA_SCREEN4,
    payload: data,
  };
}

export function fetchCountDataScreen4(region_name, naics_dropdown_value, jobtype_dropdown_value, specialized_dropdown_value) {
  return (dispatch) => {
    filterAPI
      .getCountDetailsScreen4({"region_name": region_name, "naics_dropdown_value": naics_dropdown_value, "jobtype_dropdown_value": jobtype_dropdown_value, "specialized_dropdown_value": specialized_dropdown_value })
      .then((res) => {
        let countDataScreen4 = res.data.data;
        dispatch(handleCountDataScreen4(countDataScreen4));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

function handleCountDataScreen4(data) {
  return {
    type: ActionTypesScreen4.GET_COUNT_DATA_SCREEN4,
    payload: data,
  };
}

export function fetchPercentDataScreen4(region_name, naics_dropdown_value, jobtype_dropdown_value, specialized_dropdown_value) {
  return (dispatch) => {
    filterAPI
      .getPercentDetailsScreen4({"region_name": region_name, "naics_dropdown_value": naics_dropdown_value, "jobtype_dropdown_value": jobtype_dropdown_value, "specialized_dropdown_value": specialized_dropdown_value })
      .then((res) => {
        let percentDataScreen4 = res.data.data;
        dispatch(handlePercentDataScreen4(percentDataScreen4));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

function handlePercentDataScreen4(data) {
  return {
    type: ActionTypesScreen4.GET_PERCENT_DATA_SCREEN4,
    payload: data,
  };
}

export function fetchGrowthDataScreen4(region_name, naics_dropdown_value, jobtype_dropdown_value, cross_factor_value, specialized_dropdown_value) {
  return (dispatch) => {
    filterAPI
      .getGrowthDetailsScreen4({"region_name": region_name, "naics_dropdown_value": naics_dropdown_value, "jobtype_dropdown_value": jobtype_dropdown_value, "cross_factor_value": cross_factor_value, "specialized_dropdown_value": specialized_dropdown_value })
      .then((res) => {
        let growthDataScreen4 = res.data.data;
        dispatch(handleGrowthDataScreen4(growthDataScreen4));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

function handleGrowthDataScreen4(data) {
  return {
    type: ActionTypesScreen4.GET_GROWTH_DATA_SCREEN4,
    payload: data,
  };
}



